import React, { useEffect } from "react";
import HeroSection from "./heroSection/herosection";
import Mission from "./missionSection/mission";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/footer";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow_page">
      <Navbar />
      <HeroSection />
      <Mission />
      <Footer />
    </div>
  );
}

export default About;
